module.exports = __webpack_public_path__ + "media/join.1bd77744.mp3";